__turbopack_context__.v({
  "container": "styles-module__fZck-q__container",
  "likeButton": "styles-module__fZck-q__likeButton",
  "likeCount": "styles-module__fZck-q__likeCount",
});
